import React from 'react'
import styled from 'styled-components/native'

import I18n from 'APP/I18n'

import Typography from 'APP/Converse/Typography'
import Button from 'APP/Converse/Button'

const FooterContainer = styled.View`
  align-items: center;
  gap: ${({ theme }) => theme.metrics.baseMargin};
  margin-vertical: ${({ theme }) => theme.metrics.baseMargin};
  margin-horizontal: ${({ theme }) => theme.metrics.baseMargin * 2};
`

export const CoverageFooter = ({
  isLoading,
  ctaOnPress,
}: {
  isLoading: boolean
  ctaOnPress: () => void
}) => (
  <FooterContainer>
    <Button
      variant="primary"
      widthVariant="full"
      title={I18n.t('CoverageScreen.addCoverageButton')}
      onPress={ctaOnPress}
      analyticsName="Add Coverage"
      isLoading={isLoading}
    />
    <Typography variant="bodySmall" align="center">
      {I18n.t('CoverageScreen.addCoverageDescription')}
    </Typography>
  </FooterContainer>
)
